var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagneticCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_125_15390)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_125_15390",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_125_15390",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_125_15390",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACiElEQVR4nO3dS24TQRCAYQuJVSJOwmPF4xR4wy6Wp41El5l0mUUO4F1YhuQK5EwQZQc3gCDBClA7TmQPduyZtNOF5/8kLyca6vc8wqLS6QAAAAAAAAAAAADAjbz39weir5wPp070s5Pww4n+4aNLZ1B4vZjMyofTOLs4wyRfMyfaLXw4Z/h6qy/gdIbdxiHG4/E9J/qeEJryTvC78OEwzrbJlUEM2cxtOUapG6Mba1Z+0E8n4agv4Vmvd7BTu3DL9HoHO3FWhdcPl7Obv1L6w/2Xa/2g+PD595kRvrwejh5u/F+xpZzff1R4/Vp9pqz1oJ+8TVWuDGKkihJ+zc42znqNAyevtrNXx1GC80Fn8ig4nrtKRD+uHEzhw9lckDejp0wzjYF/97xy2zpbedD0F5rrg8qy3E10Pq1XluVu9ZfHlUOpvqK1foqJ1Z4vQTaLIMYQZNuC8NGNzoAgYutLRhDJH4Egkn/wBJH8wyaI5B8wQST/UAki+QdJEMk/PIJI/oGZC5Lk/wtwjSDGEMQYghhDEGMI0tYg5l8fjSCIMQQxhiDG8FA3hiDGEMQYghhDEGMIYgxBjCGIMQQxhiDGEMQYghhDEGMIYgxBjCGIMQQxhiDGEMQYgvzvQQoJ32cPYPlMOnuqD+aC+PCt9nqmuKYu4Tm1WjHUF7XXM1UXmMWdgXdyti3gJJzUXmC2aMVfXE93J2e8xQYSnjRa8bdsCSZRmuu/HT1uvARz2ZrYad3jeB/kQb9anNHlMyOcVK+MWmtir7BIWe0sUo7iOux44IKFynwkw6rxK/HSYhm/prgqzmvfptb9cxXVzaV8dEEAvXA+fIqvtkn/XAUAAAAAAAAAAACAzvb6C8MGReUM+yaUAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneticCard);
export default __webpack_public_path__ + "static/media/Magnetic Card.ffebabb2b84a29d94b6473eabc6d8324.svg";
export { ForwardRef as ReactComponent };